// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import core from '@bmp-vue/core'
import 'phosphor-icons'
import VueFileAgent from 'vue-file-agent'
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css'
import { initDatadog } from './plugins/datadog'

const controllers = require.context('@/controllers', true, /\.js$/)
const paths = require('@/plugins/router/paths').default
let theme = require('@/plugins/vuetify/theme').default
theme = {
  ...theme,
  options: {
    customProperties: true,
    grid: {
      pageSize: [5, 10, 15, 20, 100],
      rows: 20
    }
  }
}

const App = () => import('./App')

async function bootstrap () {
  await initDatadog()

  Vue.use(VueFileAgent)
  Vue.use(VueFileAgentStyles)

  Vue.use(core, {
    controllers,
    paths,
    theme,
    mount: (options) => {
      new Vue({
        ...options,
        render: h => h(App)
      }).$mount('#app')
    }
  })
}
bootstrap()
